import { render, staticRenderFns } from "./DailyPcrTestsLineChart.vue?vue&type=template&id=5f29d7b0&"
import script from "./DailyPcrTestsLineChart.vue?vue&type=script&lang=js&"
export * from "./DailyPcrTestsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports